import { default as AdvancesIcon } from "@/components/icons/advances";
import { default as AnnouncementIcon } from "@/components/icons/announcement";
import { default as AssetIcon } from "@/components/icons/asset";
import { default as AssetManagementIcon } from "@/components/icons/assetManagement";
import { default as AssignmentIcon } from "@/components/icons/assignment";
import { default as CalendarIcon } from "@/components/icons/calendar";
import { default as CommunicationFeedbackIcon } from "@/components/icons/communicationFeedback";
import { default as EmailIcon } from "@/components/icons/email";
import { default as DashboardIcon } from "@/components/icons/dashboard";
import { default as DepartmentIcon } from "@/components/icons/building";
import { default as EmployeeManagementIcon } from "@/components/icons/employeeManagement";
import { default as EmployeesIcon } from "@/components/icons/employees";
import { default as ExamIcon } from "@/components/icons/exam";
import { default as ExpensesIcon } from "@/components/icons/expenses";
import { default as FinanceIcon } from "@/components/icons/finance";
import { default as FinancialTransactionsIcon } from "@/components/icons/financialTransactions";
import { default as Inventory } from "@/components/icons/inventory";
import { default as LeavesIcon } from "@/components/icons/leaves";
import { default as LocationIcon } from "@/components/icons/location";
import { default as LogsIcon } from "@/components/icons/logs";
import { default as StampIcon } from "@/components/icons/stamp";
import { default as BookIcon } from "@/components/icons/book";
import { default as BookmarkIcon } from "@/components/icons/bookmark";
import { default as CategoryIcon } from "@/components/icons/category";
import { default as CertificateIcon } from "@/components/icons/certificate";
import { default as OperationManagementIcon } from "@/components/icons/operationManagement";
import { default as OvertimeIcon } from "@/components/icons/overtime";
import { default as PayrollIcon } from "@/components/icons/payroll";
import { default as ProjectIcon } from "@/components/icons/projects";
import { default as ReportingIcon } from "@/components/icons/reporting";
import { default as ScaleRatingIcon } from "@/components/icons/scaleRating";
import { default as TicketsIcon } from "@/components/icons/tickets";
import { default as UserIcon } from "@/components/icons/user";
import { default as ShieldIcon } from "@/components/icons/shield";
import { default as ShiftIcon } from "@/components/icons/shift";
import { default as TimekeepingIcon } from "@/components/icons/timekeeping";
export type IconName =
  | "advances"
  | "announcement"
  | "asset"
  | "assetCategory"
  | "assetManagement"
  | "assignments"
  | "calendar"
  | "certificates"
  | "communicationFeedback"
  | "department"
  | "educationCatalog"
  | "educationManagement"
  | "educationRequests"
  | "employeeManagement"
  | "employees"
  | "entrust"
  | "examManagement"
  | "expenses"
  | "finance"
  | "financialTransactions"
  | "home"
  | "inventory"
  | "internManagement"
  | "leaves"
  | "library"
  | "location"
  | "logs"
  | "mailBroadcast"
  | "operationManagement"
  | "overtime"
  | "payroll"
  | "polls"
  | "projects"
  | "reporting"
  | "requestApproval"
  | "shift"
  | "staffTracking"
  | "supportTickets"
  | "timekeeping";

export const ICONS: Record<IconName, React.ComponentType<any>> = {
  advances: AdvancesIcon,
  announcement: AnnouncementIcon,
  asset: AssetIcon,
  assetCategory: CategoryIcon,
  assetManagement: AssetManagementIcon,
  assignments: ShieldIcon,
  calendar: CalendarIcon,
  certificates: CertificateIcon,
  communicationFeedback: CommunicationFeedbackIcon,
  department: DepartmentIcon,
  educationCatalog: BookmarkIcon,
  educationManagement: AssignmentIcon,
  educationRequests: StampIcon,
  employeeManagement: EmployeeManagementIcon,
  employees: EmployeesIcon,
  entrust: Inventory,
  examManagement: ExamIcon,
  expenses: ExpensesIcon,
  finance: FinanceIcon,
  financialTransactions: FinancialTransactionsIcon,
  home: DashboardIcon,
  inventory: Inventory,
  internManagement: UserIcon,
  leaves: LeavesIcon,
  library: BookIcon,
  location: LocationIcon,
  logs: LogsIcon,
  mailBroadcast: EmailIcon,
  operationManagement: OperationManagementIcon,
  overtime: OvertimeIcon,
  payroll: PayrollIcon,
  polls: ScaleRatingIcon,
  projects: ProjectIcon,
  reporting: ReportingIcon,
  requestApproval: StampIcon,
  shift: ShiftIcon,
  staffTracking: LogsIcon,
  supportTickets: TicketsIcon,
  timekeeping: TimekeepingIcon,
};
